import PropTypes from 'prop-types'
import React from 'react'

import Button from '../Button'
import './CancelButton.less'
import classnames from 'classnames'

const COMPONENT_CLASS = 'nmc-button-cancel'
const COMPONENT_DEFAULT_TEXT = 'cancel'
const COMPONENT_CLASS_LIGHT = 'nmc-button-cancel-light'

export default class CancelButton extends React.Component {
  render () {
    const headerClass = classnames(
      COMPONENT_CLASS, this.props.className || [],
      {[COMPONENT_CLASS_LIGHT]: this.props.light}
    )
    return (
      <Button
        {...this.props}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        className={headerClass}
      >
        {this.props.children || COMPONENT_DEFAULT_TEXT}
      </Button>
    )
  }
}

CancelButton.propTypes = Object.assign(
  {light: PropTypes.bool},
  Button.propTypes
)



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/CancelButton/index.js